import { Button } from 'antd'
import React from 'react'
import { PoweroffOutlined } from '@ant-design/icons'; // Import the loading icon


function CustomButton({
  openDeleteModal, setOpenDeleteModal,
  size = "large",
  className = "commonButton",
  title = "Sign In",
  htmlType = "",
  onClick,
  loading = false, // Prop to indicate loading state
}) {
  return (
    <>
      <Button
        size={size}
        className={className}
        htmlType={htmlType}
        onClick={onClick}
        loading={loading} // Pass the loading prop

      >
        {title}
      </Button>
    </>
  )
}

export default CustomButton
